export default "leaflet-control-boxzoom-4be5d249281d260e.svg"